import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { setTranslationServiceStatus } from "features/translationServiceSlice";
import { TRANSPERFECT_SCRIPT_URL, TRANSPERFECT_SCRIPT_DATA_OLJS } from "utilities/Constant";
import { hasExplicitUserLanguageSelection } from "utilities/getPreferredLanguage";
import { isRegistrationTranslationDeferPath } from "utilities/langPrefCookie";

const SCRIPT_ID = "transperfect-globallink-script";

export const useTranslationScript = (): void => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { data: featureFlag } = useGetFeatureFlagsQuery();
  const allowTranslationOnPath =
    !isRegistrationTranslationDeferPath(pathname) || hasExplicitUserLanguageSelection();

  useEffect(() => {
    if (!featureFlag?.preferredLanguageEnabled || !allowTranslationOnPath) {
      return;
    }

    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.type = "text/javascript";
    script.src = TRANSPERFECT_SCRIPT_URL;
    script.setAttribute("referrerpolicy", "no-referrer-when-downgrade");
    script.dataset.oljs = TRANSPERFECT_SCRIPT_DATA_OLJS;

    script.onload = () => {
      dispatch(setTranslationServiceStatus("loaded"));
    };

    script.onerror = () => {
      dispatch(setTranslationServiceStatus("failed"));
    };

    document.head.insertBefore(script, document.head.firstChild);
  }, [featureFlag?.preferredLanguageEnabled, allowTranslationOnPath, dispatch]);
};
